import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Chip,
  Select,
  MenuItem,
  FormLabel,
  FormControl,
  FormHelperText,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  InputBase,
  styled,
  Autocomplete,
  Grid2,
  Checkbox
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useFormik } from "formik";
import * as yup from "yup";
import React, { useState, useEffect, useMemo } from 'react';


import PrimaryIcon from "Components/Common/PrimaryIcon";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { useDispatch, useSelector } from "react-redux";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { addPost } from "Slices/thunks";
import { toast } from "react-toastify";

const toolbar = [
  'bold', 
  'italic', 
  'link', 
  'bulletedList', 
  'numberedList', 
  // 'uploadImage'
]

const styles = (theme) => ({
  '& .ck-editor__editable': {
    padding: "0 20px",
    height: "220px !important"
  }
})

const initialValues = {
  Title: "",
  Description: "",
  TopicID: null,
  TagIDs: null
}

const PostDialog = ({ open, setOpen }) => {
  const dispatch = useDispatch();

  const { Tags, Topics, Translation } = useSelector((state) => ({
    Tags: state.DiscussionHub.tags || [],
    Topics: state.DiscussionHub.topics || [],
    Translation: state.Translation.translation?.DiscussionHub || {},
  }));

  const Schema = useMemo(() => {
    return yup.object({
      Title: yup.string().required(Translation?.TitleRequired || "Title is required field."),
      Description: yup.string().required(Translation?.DescriptionRequired || "Description is required field."),
      TopicID: yup.string().required(Translation?.TopicRequired || "Topic is required field."),
      TagIDs: yup.array().required(Translation?.TagRequired || "Tag is required field.")
    });
  }, [Translation]) 

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    touched,
    submitCount,
    resetForm,
    setValues,
    setFieldTouched,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: async (data) => {
      try {
        await dispatch(addPost(data)).unwrap();
        setOpen(false);
        toast.success(Translation?.PostCreatedSuccessfully);

      } catch (error) {
        toast.error(Translation?.SomethingWentWrong);
        
      }
    },
    validationSchema: Schema,
  });

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      resetForm({})
      setValues(initialValues);
    }

  }, [open])

  return (
    <Dialog fullWidth maxWidth={"lg"} open={open} onClose={handleClose}>
      <DialogTitle>
        {Translation?.NewPost}
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <DialogContent>
      
          <Grid2 spacing={2} container sx={styles}>
            <Grid2 size={6}>
              <Paper elevation={0} sx={{ p: {xs: 2, md: 3}, borderRadius: '8px' }}>
              {/* Title Input */}
              <TextField
                fullWidth
                variant="standard"
                placeholder={Translation?.TypeTitle}
                error={touched.Title && errors.Title}
                helperText={touched.Title && errors.Title && errors.Title}
                onChange={handleChange}
                onBlur={handleBlur}
                name="Title"
                value={values?.Title || ""}
                sx={{ mb: 2 }}
                // InputProps={{ disableUnderline: true }}
              />

              {/* Categories and Tags */}
              <Stack direction="column" spacing={1} sx={{ my: 2, alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>

                <FormControl variant="standard" fullWidth>
                  <Autocomplete
                    options={Topics}
                    autoHighlight
                    getOptionLabel={(option) => option.Name}
                    clearIcon={false}
                    onBlur={handleBlur}
                    value={(Topics || []).find((item) => item.ID == values.TopicID)}
                    onChange={(value, newVal) => setFieldValue("TopicID", newVal?.ID)}
                    noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                    renderOption={(props, option) => {
                      const { key, ...optionProps } = props;
                      return (
                        <Typography key={key} {...optionProps}>
                          {option?.Name}
                        </Typography>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        name="TopicID"
                        placeholder={Translation?.PleaseSelectCategory}
                        error={touched.TopicID && errors.TopicID}
                        helperText={touched.TopicID && errors.TopicID && errors.TopicID}
                        slotProps={{
                          htmlInput: {
                            ...params.inputProps,
                            autoComplete: "new-password",
                          },
                        }}
                      />
                    )}
                  />
                </FormControl>

                {/* Add Tag Dropdown */}
                {/* <FormControl variant="standard">
                  <Select
                    value=""
                    onChange={handleAddTag}
                    displayEmpty
                    input={<CustomSelect />}
                    renderValue={(value) => {
                      return <Box sx={{ color: "text.secondary" }}>Select your tag</Box>;
                    }}
                  >
                    <MenuItem disabled value=""><em>Select your tag</em></MenuItem>
                    {availableTags.filter(t => !tags.includes(t)).map(tag => (
                      <MenuItem key={tag} value={tag}>{tag}</MenuItem>
                    ))}
                  </Select>
                </FormControl> */}


                {/* <FormControl variant="standard">
                  <Autocomplete
                    options={Tags}
                    autoHighlight
                    getOptionLabel={(option) => option.Value}
                    clearIcon={false}
                    // value={selectedOption}
                    // onBlur={onBlur}
                    // onChange={(value, newVal) => onChange(newVal)}
                    sx={{ width: 200 }}
                    noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                    renderOption={(props, option) => {
                      const { key, ...optionProps } = props;
                      return (
                        <Typography key={key} {...optionProps}>
                          {option?.Name}
                        </Typography>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        // error={Boolean(error)}
                        name="GenderID"
                        placeholder={Translation?.SelectYourTag}
                        // helperText={error}
                        slotProps={{
                          htmlInput: {
                            ...params.inputProps,
                            autoComplete: "new-password",
                          },
                        }}
                      />
                    )}
                  />
                </FormControl> */}

                <FormControl variant="standard" fullWidth>
                  <Autocomplete
                    multiple={true}
                    options={Tags}
                    disableCloseOnSelect
                    autoHighlight
                    clearIcon={false}
                    getOptionLabel={(option) => option.Name}
                    // value={(Tags || []).find((item) => Array.isArray(values.TagIDs) ? values.TagIDs.includes(item.ID) : "")}
                    value={(Tags || []).filter((item) => Array.isArray(values.TagIDs) && values.TagIDs.includes(item.ID))}
                    onBlur={handleBlur}
                    onChange={(event, newValue) => {
                      if (Array.isArray(newValue)) {
                        setFieldValue("TagIDs", newValue.map((item) => item.ID))
                      } else {
                        setFieldValue("TagIDs", null)
                      }
                    }}
                    noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      return (
                        <>
                          {/* <Typography key={key} {...optionProps}>
                            {option?.Name}
                          </Typography> */}
                          <li key={option.ID} {...optionProps}>
                            <Checkbox
                              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                              checkedIcon={<CheckBoxIcon fontSize="small" />}
                              placeholder={Translation?.SelectYourTag}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.Name}
                          </li>
                        </>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={Translation?.SelectTopics}
                      />
                    )}
                    // renderTags={(value, getTagProps) =>
                    //   values.TagIDs?.map((option, index) => (
                    //     <Chip
                    //       variant="outlined"
                    //       label={option.Name}
                    //       {...getTagProps({ index })}
                    //     />
                    //   ))
                    // }
                  />
                </FormControl>
              </Stack>

              {/* Editor Toolbar */}
              <FormControl variant="standard" fullWidth>
                <CKEditor
                  editor={ClassicEditor}
                  data={values.Description}
                  config={{toolbar}}
                  onBlur={() => setFieldTouched("Description", true)}
                  onChange={(event, editor) => {
                    setFieldValue("Description", editor.getData())
                  }}
                />
                {/* {touched.Description && errors.Description && ( */}
                {(touched.Description || submitCount > 0) && errors.Description &&  (
                  <FormHelperText color="error.main" sx={(theme) => ({color: theme.palette.error.main})} >{errors.Description}</FormHelperText>
                )}
              </FormControl>

              {/* <Box
                sx={{
                  border: '1px solid #dee2e6',
                  borderBottom: 'none',
                  borderRadius: '4px 4px 0 0',
                  p: 0.5,
                }}
              >
                <ToggleButtonGroup
                  size="small"
                  value={formats}
                  onChange={handleFormat}
                  aria-label="text formatting"
                  sx={{ '& .MuiToggleButton-root': { border: 'none' } }}
                >
                  <ToggleButton value="bold" aria-label="bold"><FormatBoldIcon /></ToggleButton>
                  <ToggleButton value="italic" aria-label="italic"><FormatItalicIcon /></ToggleButton>
                  <ToggleButton value="link" aria-label="link"><LinkIcon /></ToggleButton>
                  <ToggleButton value="bulleted-list" aria-label="bulleted list"><FormatListBulletedIcon /></ToggleButton>
                  <ToggleButton value="numbered-list" aria-label="numbered list"><FormatListNumberedIcon /></ToggleButton>
                  <ToggleButton value="image" aria-label="image"><ImageOutlinedIcon /></ToggleButton>
                  <ToggleButton value="code" aria-label="code"><CodeIcon /></ToggleButton>
                  <ToggleButton value="subject" aria-label="subject"><SubjectIcon /></ToggleButton>
                </ToggleButtonGroup>
              </Box> */}

              {/* Main Text Area */}
              {/* <TextField
                fullWidth
                multiline
                rows={12}
                placeholder="Write something to post"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '0 0 4px 4px',
                    '& fieldset': {
                      borderColor: '#dee2e6',
                    },
                    '&:hover fieldset': {
                      borderColor: '#adb5bd',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#80bdff',
                    },
                  },
                }}
              /> */}
            </Paper>
              
            </Grid2>
            <Grid2 size={6}>
              <Box dangerouslySetInnerHTML={{__html: values.Description}} mt={3}></Box>
            </Grid2>
          </Grid2>

        </DialogContent>
        <DialogActions align="center" mt={2}>
          <Button type="submit" variant="contained">
            {Translation?.CreatePost}
          </Button>
          <Button
            onClick={() => handleClose()}
            variant="outlined"
            color="secondary"
          >
            {Translation?.Cancel}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default PostDialog;